<template>
  <!--  <van-overlay show @click="$emit('close')" class="flex" z-index="1000">-->
  <!--  </van-overlay>-->
</template>

<script>
import { Dialog } from 'vant'

export default {
  name: 'MessageBox',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    Dialog.alert({
      // title: this.data.title || '提示',
      message: this.data.message || ''
    }).then(() => {
      // on close
    })
  }
}
</script>

<style scoped>

</style>